
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.a1599785005 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b194319507 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b918236025 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a116900366 = numberParserFn([{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b2115478879 = pluralGeneratorFn(function(n
) {
  return 'other';
});
Globalize.a1465958513 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1580535289 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b655111470 = messageFormatterFn((function(  ) {
  return function(d) { return "이메일 주소"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1969280697 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a494617702 = messageFormatterFn((function(  ) {
  return function(d) { return "이 기기는 공유 기기입니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1905577503 = messageFormatterFn((function(  ) {
  return function(d) { return "공유 기기를 사용하고 계신가요? 이 확인란을 체크하여 로그인하는 데 드는 시간을 절약하실 수 있어요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1669906054 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인 상태 유지"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b884776676 = messageFormatterFn((function(  ) {
  return function(d) { return "이 확인란을 선택하면 계정에서 자동으로 로그아웃될 때까지 이 기기에서 로그인 상태가 유지됩니다. 공유 기기에서는 이 확인란을 선택하지 마십시오."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a961771516 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호를 잊으셨나요?"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b169226413 = messageFormatterFn((function(  ) {
  return function(d) { return "계속하기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1873142554 = messageFormatterFn((function(  ) {
  return function(d) { return "취소"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a430311203 = messageFormatterFn((function(  ) {
  return function(d) { return "돌아가기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1159307173 = messageFormatterFn((function(  ) {
  return function(d) { return "다시 로드"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a425760362 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인함으로써 본인은 " + d["0"] + " <a href=" + d["1"] + " " + d["3"] + ">이용약관</a> 및 <a href=" + d["2"] + " " + d["4"] + ">개인정보 처리방침</a>에 동의합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1178503624 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인함으로써 본인은 " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">이용약관</a>, <a href=" + d["2"] + " " + d["6"] + ">개인정보 처리방침</a> 및 <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " 이용약관</a>에 동의합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1709939360 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인함으로써 " + d["4"] + "에도 가입합니다. 본인은 " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">이용약관</a>, <a href=" + d["2"] + " " + d["6"] + ">개인정보 처리방침</a> 및 <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " 이용약관</a>에 동의합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1718477259 = messageFormatterFn((function(  ) {
  return function(d) { return "정기 보안 점검 과정에서 고객님의 계정 사용이 일시 중지되었습니다. 고객님의 계정은 안전한 상태이지만, 비밀번호 재설정이 필요합니다. 로그인하려면 아래의 \"비밀번호를 잊으셨나요?\" 링크에서 비밀번호를 변경해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1110105877 = messageFormatterFn((function(  ) {
  return function(d) { return "이메일 주소와 비밀번호가 일치하지 않습니다. 다시 시도해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b561834458 = messageFormatterFn((function(  ) {
  return function(d) { return "죄송합니다. 문제가 있는 것 같습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a786678828 = messageFormatterFn((function(  ) {
  return function(d) { return "죄송합니다. 문제가 있는 것 같습니다. 잠시 기다린 후 다시 시도해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1184988342 = messageFormatterFn((function(  ) {
  return function(d) { return "이메일 주소를 입력해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a952292059 = messageFormatterFn((function(  ) {
  return function(d) { return "올바른 이메일 주소를 입력해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1947376831 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호를 입력해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1536771049 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인 정보 확인 중"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1274259012 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 숨기기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b959916873 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 표시"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1955266137 = messageFormatterFn((function(  ) {
  return function(d) { return "계정이 없으세요? <span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">회원가입하기</a></span>"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1293021420 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1556326979 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "를 통한 로그인은 선택 불가"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1553791263 = messageFormatterFn((function(  ) {
  return function(d) { return "동일한 이메일을 사용하여 재설정한 비밀번호로 " + d["0"] + " 계정에 액세스하실 수 있습니다. " + d["1"] + " 계정에는 영향을 미치지 않습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a786392527 = messageFormatterFn((function(  ) {
  return function(d) { return "아래의 버튼을 사용하여 비밀번호를 재설정해 주세요. 다음에는 이메일과 새 비밀번호로 " + d["0"] + "에 직접 로그인하실 수 있습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b998001592 = messageFormatterFn((function(  ) {
  return function(d) { return "SSO 로그인"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b2146758512 = messageFormatterFn((function(  ) {
  return function(d) { return "통합 인증을 사용하여 로그인"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b2139621532 = messageFormatterFn((function(  ) {
  return function(d) { return "또는 " + d["0"] + " 계정 사용"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b591513193 = messageFormatterFn((function(  ) {
  return function(d) { return "포인트를 적립해 무료로 여행하실 수 있어요! 회원가로 비용을 절약하고 간편하게 일정을 확인해 보세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b419690575 = messageFormatterFn((function(  ) {
  return function(d) { return "여행 완료 후 " + d["0"] + " 익스피디아 리워드 포인트를 적립해 보세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1824245138 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 계정 로그인"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1984157654 = messageFormatterFn((function(  ) {
  return function(d) { return "새 탭에서 열기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b928532558 = messageFormatterFn((function(  ) {
  return function(d) { return "이용약관 (" + d["0"] + ")"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1003977900 = messageFormatterFn((function(  ) {
  return function(d) { return "개인정보 처리방침 (" + d["0"] + ")"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a189299287 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key 회원혜택 프로그램 이용약관 (" + d["0"] + ") "; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b238131444 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호를 잊으셨나요?"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1606080747 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 재설정"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a931572955 = messageFormatterFn((function(  ) {
  return function(d) { return "이메일을 입력해 주세요. 비밀번호 재설정을 위한 링크를 보내드립니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1525249871 = messageFormatterFn((function(  ) {
  return function(d) { return "재설정 링크 보내기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a717201554 = messageFormatterFn((function(  ) {
  return function(d) { return "받은 편지함을 확인해 주세요!"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a40118842 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 주소로 비밀번호를 재설정할 수 있는 링크를 보내드렸습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a40119803 = messageFormatterFn((function(  ) {
  return function(d) { return "이메일을 수신하는 데 몇 분이 걸릴 수 있습니다. 10분 후에도 받지 못한 경우에는 정크 또는 스팸 메일함을 확인해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1021364421 = messageFormatterFn((function(  ) {
  return function(d) { return "링크 재전송"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b2065492387 = messageFormatterFn((function(  ) {
  return function(d) { return "새 링크가 전송되었습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1087855216 = messageFormatterFn((function(  ) {
  return function(d) { return "계정 확인 중"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a84392080 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 설정"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a2062543079 = messageFormatterFn((function(  ) {
  return function(d) { return "다시 오신 것을 환영합니다!"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1534446431 = messageFormatterFn((function(  ) {
  return function(d) { return "계속하려면 고유한 비밀번호를 생성해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1607570230 = messageFormatterFn((function(  ) {
  return function(d) { return "재설정되었습니다!"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1041377095 = messageFormatterFn((function(  ) {
  return function(d) { return "이제 새 비밀번호를 이용해 계속해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b629102306 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 재설정"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a2053931615 = messageFormatterFn((function(  ) {
  return function(d) { return "죄송합니다. 이 요청 링크는 만료되었습니다. 아직 비밀번호 변경이 필요하신 경우에는 아래를 클릭하여 새로운 비밀번호 재설정 이메일 전송을 요청해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1939919663 = messageFormatterFn((function(  ) {
  return function(d) { return "링크 재전송"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1780042150 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 저장 중"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1198961934 = messageFormatterFn((function(  ) {
  return function(d) { return "회원가입"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b2049276358 = messageFormatterFn((function(  ) {
  return function(d) { return "회원가입"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a613271153 = messageFormatterFn((function(  ) {
  return function(d) { return "이메일 주소"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b35552279 = messageFormatterFn((function(  ) {
  return function(d) { return "이메일 주소를 입력해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1693852346 = messageFormatterFn((function(  ) {
  return function(d) { return "올바른 이메일 주소를 입력해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b594241776 = messageFormatterFn((function(  ) {
  return function(d) { return "이름"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1113381000 = messageFormatterFn((function(  ) {
  return function(d) { return "이름을 입력해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a739755726 = messageFormatterFn((function(  ) {
  return function(d) { return "성"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1006274986 = messageFormatterFn((function(  ) {
  return function(d) { return "성을 입력해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b198749745 = messageFormatterFn((function(  ) {
  return function(d) { return "이름은 영문자로만 입력해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1590138184 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b155892528 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호를 입력해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1890391969 = messageFormatterFn((function(  ) {
  return function(d) { return "올바른 비밀번호를 입력해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a476265153 = messageFormatterFn((function(  ) {
  return function(d) { return "9~64자 길이"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a476266114 = messageFormatterFn((function(  ) {
  return function(d) { return "문자 및 숫자 조합"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a476267075 = messageFormatterFn((function(  ) {
  return function(d) { return "특수 문자(예: ~ " + "#" + " @ $ % & ! * _ ? ^ -)"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a476268036 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호에는 공백을 포함할 수 없습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1769269781 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호는 8~64자 길이여야 합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a414804226 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호는 이메일 주소와 달라야 합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1383488319 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호에는 공백을 포함할 수 없습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b668352841 = messageFormatterFn((function(  ) {
  return function(d) { return "회원가입함으로써 본인은 " + d["0"] + " <a href=" + d["1"] + " " + d["3"] + ">이용약관</a> 및 <a href=" + d["2"] + " " + d["4"] + ">개인정보 처리방침</a>에 동의합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1597050101 = messageFormatterFn((function(  ) {
  return function(d) { return "회원가입함으로써 본인은 " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">이용약관</a>, <a href=" + d["2"] + " " + d["6"] + ">개인정보 처리방침</a> 및 <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + "이용약관</a>에 동의합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1558537324 = messageFormatterFn((function(  ) {
  return function(d) { return "여행 특가 상품, 특별 혜택 및 기타 정보가 포함된 " + d["0"] + "의 이메일을 받겠습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1309265283 = messageFormatterFn((function(  ) {
  return function(d) { return "여행 특가 상품, 특별 혜택 및 기타 정보가 포함된 " + d["0"] + "의 이메일을 받겠습니다. 언제든지 프로모션 이메일의 구독을 취소하실 수 있습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a2117914031 = messageFormatterFn((function(  ) {
  return function(d) { return "여행 아이디어, 특별 혜택 및 기타 정보가 포함된 " + d["0"] + "의 이메일을 받겠습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1724959008 = messageFormatterFn((function(  ) {
  return function(d) { return "여행 아이디어, 특별 혜택 및 기타 정보가 포함된 " + d["0"] + "의 이메일을 받겠습니다. 언제든지 프로모션 이메일의 구독을 취소하실 수 있습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b904774828 = messageFormatterFn((function(  ) {
  return function(d) { return "계속하기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b584981569 = messageFormatterFn((function(  ) {
  return function(d) { return "이미 회원이세요? <span><a id=\"signinRedirectLink\" href=" + d["0"] + ">로그인하기</a></span>"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a355242270 = messageFormatterFn((function(  ) {
  return function(d) { return "안녕하세요, " + d["0"] + " 님!"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1894982248 = messageFormatterFn((function(  ) {
  return function(d) { return "새 " + d["0"] + " 계정으로 이제 전 세계로 여행을 떠나보세요!"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1439719375 = messageFormatterFn((function(  ) {
  return function(d) { return "계속하기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b42734144 = messageFormatterFn((function(  ) {
  return function(d) { return "계속하려면 비밀번호를 보안상 더 강하게 설정해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1335355131 = messageFormatterFn((function(  ) {
  return function(d) { return "8자 이상이어야 합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a96838057 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 보안 강도"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1063761031 = messageFormatterFn((function(  ) {
  return function(d) { return "약함"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1828090536 = messageFormatterFn((function(  ) {
  return function(d) { return "강함"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a458495406 = messageFormatterFn((function(  ) {
  return function(d) { return "매우 강함"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1456451721 = messageFormatterFn((function(  ) {
  return function(d) { return "유추 가능한 대체 문자를 사용하지 않습니다(예: a 대신 @)."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b670754657 = messageFormatterFn((function(  ) {
  return function(d) { return "일반적인 단어의 철자를 거꾸로 사용하지 않습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a350160505 = messageFormatterFn((function(  ) {
  return function(d) { return "대문자를 일부 사용하되 모두 대문자로 사용하지 않습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a178534554 = messageFormatterFn((function(  ) {
  return function(d) { return "첫 문자 외에도 대문자를 사용합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1312618498 = messageFormatterFn((function(  ) {
  return function(d) { return "본인과 관련된 날짜 및 연도를 사용하지 않습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1438143304 = messageFormatterFn((function(  ) {
  return function(d) { return "최근 연도를 사용하지 않습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1427283693 = messageFormatterFn((function(  ) {
  return function(d) { return "본인과 관련된 연도를 사용하지 않습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1299175034 = messageFormatterFn((function(  ) {
  return function(d) { return "일반적인 문자 배열을 사용하지 않습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b193919660 = messageFormatterFn((function(  ) {
  return function(d) { return "반복적인 단어 및 문자를 사용하지 않습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1771770440 = messageFormatterFn((function(  ) {
  return function(d) { return "키보드의 문자 배열을 그대로 사용하지 않고 패턴을 길고 다양하게 사용합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1247454371 = messageFormatterFn((function(  ) {
  return function(d) { return "일반적이지 않은 단어를 추가합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1566200567 = messageFormatterFn((function(  ) {
  return function(d) { return "여러 단어를 사용하고 일반적인 구는 사용하지 않습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b724785236 = messageFormatterFn((function(  ) {
  return function(d) { return "기호, 숫자 또는 대문자를 사용하지 않고도 강력한 비밀번호를 설정하실 수 있습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1702913741 = messageFormatterFn((function(  ) {
  return function(d) { return "이 이메일 주소는 이미 " + d["0"] + " 계정과 연결되어 있습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a16156987 = messageFormatterFn((function(  ) {
  return function(d) { return "회원가입을 완료하실 수 있도록 링크를 이메일로 보내드렸습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b843462806 = messageFormatterFn((function(  ) {
  return function(d) { return "회원가입 요청 진행 중"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a664943958 = messageFormatterFn((function(  ) {
  return function(d) { return "이름은 2자 이상이어야 합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1802791640 = messageFormatterFn((function(  ) {
  return function(d) { return "성은 2자 이상이어야 합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1912993796 = messageFormatterFn((function(  ) {
  return function(d) { return "이름은 최대 100자까지 작성하실 수 있습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1244125818 = messageFormatterFn((function(  ) {
  return function(d) { return "성은 최대 100자까지 작성하실 수 있습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a562744831 = messageFormatterFn((function(  ) {
  return function(d) { return "이름에는 특수 문자를 포함할 수 없습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1182293247 = messageFormatterFn((function(  ) {
  return function(d) { return "성에는 특수 문자를 포함할 수 없습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1095591651 = messageFormatterFn((function(  ) {
  return function(d) { return "아래에 모두 동의합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b529975703 = messageFormatterFn((function(  ) {
  return function(d) { return "본인은 만 18세 이상이며 <a href=" + d["0"] + " " + d["1"] + ">이용약관</a> 및 <a href=" + d["2"] + " " + d["3"] + ">" + d["4"] + " 이용약관</a>을 읽었고 이에 동의합니다(필수)."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a269153401 = messageFormatterFn((function(  ) {
  return function(d) { return "<a href=" + d["0"] + " " + d["1"] + ">개인정보 처리방침</a>에 설명된 대로 개인정보를 수집 및 사용하는 것에 동의합니다(필수)."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b254337868 = messageFormatterFn((function(  ) {
  return function(d) { return "<a href=" + d["0"] + " " + d["1"] + ">개인정보 처리방침</a>에 설명된 대로 국내 또는 해외에서 제3자에게 개인정보를 제공하는 데 동의합니다(필수)."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1783592753 = messageFormatterFn((function(  ) {
  return function(d) { return "계속하려면 약관에 동의해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a835063917 = messageFormatterFn((function(  ) {
  return function(d) { return "계속하려면 약관에 동의해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1300639913 = messageFormatterFn((function(  ) {
  return function(d) { return "계속하려면 상자를 체크해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b121593822 = messageFormatterFn((function(  ) {
  return function(d) { return "또는 " + d["0"] + " 계정으로 회원가입"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a149617628 = messageFormatterFn((function(  ) {
  return function(d) { return "공백, 사용자 이름, 이메일 주소 또는 이전에 사용하신 비밀번호를 사용하지 말아주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b122187008 = messageFormatterFn((function(  ) {
  return function(d) { return "죄송합니다. 문제가 있는 것 같습니다. 잠시 후 다시 시도해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1379970534 = messageFormatterFn((function(  ) {
  return function(d) { return "휴대폰 번호 인증"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1679183785 = messageFormatterFn((function(  ) {
  return function(d) { return "계정 보안을 위해 입력하신 휴대폰 번호로 1회용 인증 코드를 보내드립니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1262921744 = messageFormatterFn((function(  ) {
  return function(d) { return "보내기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1317577897 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + ". All rights reserved."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1498007205 = messageFormatterFn((function(  ) {
  return function(d) { return "이용약관"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1437865894 = messageFormatterFn((function(  ) {
  return function(d) { return "개인정보 보호정책"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a804472291 = messageFormatterFn((function(  ) {
  return function(d) { return "문자 메시지 보내기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1966153746 = messageFormatterFn((function(  ) {
  return function(d) { return "인증 코드 입력"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a824671236 = messageFormatterFn((function(  ) {
  return function(d) { return "인증 코드"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a745926583 = messageFormatterFn((function(  ) {
  return function(d) { return "코드 다시 보내기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b454234764 = messageFormatterFn((function(  ) {
  return function(d) { return "휴대폰 번호 변경"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b501990464 = messageFormatterFn((function(  ) {
  return function(d) { return "인증 코드가 다시 전송되었습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b431386681 = messageFormatterFn((function(  ) {
  return function(d) { return "방금 " + d["0"] + "번으로 보내드린 6자리 인증 코드를 입력해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1390031846 = messageFormatterFn((function(  ) {
  return function(d) { return "인증 코드 확인 중"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b121927711 = messageFormatterFn((function(  ) {
  return function(d) { return "잘못된 코드입니다. 코드 다시 보내기를 클릭해 다시 시도해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1610229883 = messageFormatterFn((function(  ) {
  return function(d) { return "또는 다음으로 계속하기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1928525205 = messageFormatterFn((function(  ) {
  return function(d) { return "수천 개 호텔에서 회원으로 평균 " + d["0"] + "% 할인받으세요. 언제나 무료로 이용하실 수 있어요!"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a202022179 = messageFormatterFn((function(  ) {
  return function(d) { return "또는"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a521645793 = messageFormatterFn((function(  ) {
  return function(d) { return "다른 로그인 옵션"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a522005207 = messageFormatterFn((function(  ) {
  return function(d) { return "다른 회원가입 옵션"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1062664685 = messageFormatterFn((function(  ) {
  return function(d) { return "Google 계정으로 회원가입"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b640471950 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인할 수 없습니다. 다시 시도하거나 이 사이트에 회원가입하고 계속해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a453622892 = messageFormatterFn((function(  ) {
  return function(d) { return "전화번호를 통한 로그인 옵션을 이용하실 수 없습니다. 소셜 미디어 계정에서 이메일 공유가 설정되었는지 확인해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1112150884 = messageFormatterFn((function(  ) {
  return function(d) { return "수천 개 호텔에서 회원으로 " + d["0"] + "% 이상 할인받으세요. 언제나 무료로 이용하실 수 있어요!"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a898556489 = messageFormatterFn((function(  ) {
  return function(d) { return "Google 계정으로 로그인"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1641424094 = messageFormatterFn((function(  ) {
  return function(d) { return "네이버 계정으로 로그인"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1579022888 = messageFormatterFn((function(  ) {
  return function(d) { return "최대 로그인 시도 횟수를 초과했습니다. 잠시 후 다시 시도해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1016806341 = messageFormatterFn((function(  ) {
  return function(d) { return "생체 정보를 사용하여 로그인"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b42597115 = messageFormatterFn((function(  ) {
  return function(d) { return "생체 정보를 사용하여 로그인하면 비밀번호를 입력하실 필요가 없습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1281934286 = messageFormatterFn((function(  ) {
  return function(d) { return "시작하기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1818456254 = messageFormatterFn((function(  ) {
  return function(d) { return "나중에 알림"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1051343948 = messageFormatterFn((function(  ) {
  return function(d) { return "성공!"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1787940690 = messageFormatterFn((function(  ) {
  return function(d) { return "생체 정보 로그인이 활성화되었습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a549551958 = messageFormatterFn((function(  ) {
  return function(d) { return "생체 정보를 사용하여 로그인"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1258145755 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 사용"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b105512614 = messageFormatterFn((function(  ) {
  return function(d) { return "생체 정보 사용"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b447139155 = messageFormatterFn((function(  ) {
  return function(d) { return "계속하려면 비밀번호를 업데이트해 주세요"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1170169745 = messageFormatterFn((function(  ) {
  return function(d) { return "계정에 액세스하려면 비밀번호를 업데이트해 주셔야 합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1062894139 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 재설정"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a926037733 = messageFormatterFn((function(  ) {
  return function(d) { return "이제 회원 특전을 누려보세요!"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1356961973 = messageFormatterFn((function(  ) {
  return function(d) { return "저희가 드리는 $" + d["0"] + " 상당의 포인트와 함께 다음 여행을 시작해 보세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1307085637 = messageFormatterFn((function(  ) {
  return function(d) { return "포인트를 계정에서 바로 확인하고 첫 예약에 사용하실 수 있어요. 결제 시 포인트 적용이 가능한 옵션을 찾아보세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b773806925 = messageFormatterFn((function(  ) {
  return function(d) { return "익스피디아 회원이 되신 것을 환영합니다!"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b2089944355 = messageFormatterFn((function(  ) {
  return function(d) { return "회원가로 즉시 할인받고 예약 시 포인트를 적립해 보세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1133369554 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인 또는 회원가입"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b272066360 = messageFormatterFn((function(  ) {
  return function(d) { return "수천 개 호텔에서 회원으로 평균 " + d["0"] + "% 할인받으세요. 언제나 무료로 이용하실 수 있어요!"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1869425658 = messageFormatterFn((function(  ) {
  return function(d) { return "계속하면 <a href=" + d["1"] + " " + d["3"] + ">이용약관</a> 및 <a href=" + d["2"] + " " + d["4"] + ">개인정보 처리방침</a>에 동의하시는 것으로 간주됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1169134936 = messageFormatterFn((function(  ) {
  return function(d) { return "계속하면 <a href=" + d["1"] + " " + d["5"] + ">이용약관</a>, <a href=" + d["2"] + " " + d["6"] + ">개인정보 처리방침</a> 및 <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " 이용약관</a>을 읽었으며 이에 동의하시는 것으로 간주됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1094248893 = messageFormatterFn((function(  ) {
  return function(d) { return "계속하면 <a href=" + d["1"] + " " + d["4"] + ">이용약관</a>, <a href=" + d["2"] + " " + d["5"] + ">개인정보 처리방침</a> 및 <a href=" + d["3"] + " " + d["6"] + ">One Key 회원혜택 프로그램 이용약관</a>을 읽었으며 이에 동의하시는 것으로 간주됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1537546367 = messageFormatterFn((function(  ) {
  return function(d) { return "이메일"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1822795141 = messageFormatterFn((function(  ) {
  return function(d) { return "올바른 이메일 주소를 입력해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1795954110 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1872443531 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1689971403 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1440005244 = messageFormatterFn((function(  ) {
  return function(d) { return "개인 기기에서만 선택해 주세요. 계정 보안을 위해 공유 기기에서는 이 옵션을 선택하지 말아 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1816100491 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인 시도 횟수가 너무 많습니다. 다시 시도하려면 " + d["0"] + "분을 기다려 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1890984199 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인 시도 횟수가 너무 많습니다. 다시 시도하려면 " + d["0"] + "분을 기다려 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1886088865 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인 시도 횟수가 너무 많습니다. 다시 시도하려면 " + d["0"] + "분을 기다려 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1899546709 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인 시도 횟수가 너무 많습니다. 다시 시도하려면 " + d["0"] + "분을 기다려 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1440117890 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인 시도 횟수가 너무 많습니다. 다시 시도하려면 " + d["0"] + "분을 기다려 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b288086237 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인 시도 횟수가 너무 많습니다. 다시 시도하려면 " + d["0"] + "분을 기다려 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b2114802606 = messageFormatterFn((function(  ) {
  return function(d) { return "익스피디아, 호텔스닷컴 및 Vrbo에서 하나의 계정을 사용해 리워드 혜택을 즐겨보세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a592372390 = messageFormatterFn((function(  ) {
  return function(d) { return "익스피디아, 호텔스닷컴 및 Vrbo에서 하나의 계정을 사용해 여행을 즐겨보세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1335430483 = messageFormatterFn((function(  ) {
  return function(d) { return "숙박 시설을 검색해 저장하고, 일행과 계획을 세우며 예약 세부 정보를 확인해 보세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1734919892 = messageFormatterFn((function(  ) {
  return function(d) { return "정기 보안 점검 과정에서 고객님의 계정 사용이 일시 중지되었습니다. 고객님의 계정은 안전한 상태이지만, 비밀번호 재설정이 필요합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a457051844 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인하고 예약해 OneKeyCash를 적립해 보세요!"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b891444080 = messageFormatterFn((function(  ) {
  return function(d) { return "사용자 확인"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1320635466 = messageFormatterFn((function(  ) {
  return function(d) { return "이메일로 보내드린 보안 코드를 입력해 주세요. 받은 편지함에 없는 경우 스팸 메일함을 확인해 보세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1751341854 = messageFormatterFn((function(  ) {
  return function(d) { return "이메일 확인"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b708996424 = messageFormatterFn((function(  ) {
  return function(d) { return "계속하려면 " + d["0"] + " 주소로 보내드린 보안 코드를 입력해 주세요. 받은 편지함에 없는 경우 스팸 메일함을 확인해 보세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b208857394 = messageFormatterFn((function(  ) {
  return function(d) { return "6자리 코드"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1614017870 = messageFormatterFn((function(  ) {
  return function(d) { return "코드 다시 보내기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b77060827 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + ")"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1049063891 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "초 후 코드 다시 보내기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1970121373 = messageFormatterFn((function(  ) {
  return function(d) { return "이메일을 못 받으셨나요?"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1130265791 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "초 후에 다른 코드를 요청하실 수 있습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b422982264 = messageFormatterFn((function(  ) {
  return function(d) { return "다른 보안 코드 요청"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1551682670 = messageFormatterFn((function(  ) {
  return function(d) { return "받은 편지함으로 새로운 6자리 코드를 보내드렸습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1018372899 = messageFormatterFn((function(  ) {
  return function(d) { return "이 옵션 대신 비밀번호 입력"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1622466308 = messageFormatterFn((function(  ) {
  return function(d) { return "올바르지 않은 코드입니다. 다시 시도해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a513967666 = messageFormatterFn((function(  ) {
  return function(d) { return "만료된 코드입니다. 재전송을 요청한 다음 다시 시도해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a470119207 = messageFormatterFn((function(  ) {
  return function(d) { return "받은 편지함에 없는 경우 스팸 메일함을 확인해 보세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a2115647822 = messageFormatterFn((function(  ) {
  return function(d) { return "사용자 경험이 업데이트되었으며, 사용자 확인을 위해서는 이메일을 확인해주셔야 합니다. 받은 편지함으로 보내 드린 보안 코드를 입력해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1475586801 = messageFormatterFn((function(  ) {
  return function(d) { return "문제가 있는 것 같습니다. 다시 시도해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1476550982 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인 방법을 변경하려면 이메일로 보내드린 보안 코드를 입력해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b634688884 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 입력"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b2065660731 = messageFormatterFn((function(  ) {
  return function(d) { return "이메일로 보안 코드 전송"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a676442875 = messageFormatterFn((function(  ) {
  return function(d) { return "이메일 주소와 비밀번호가 일치하지 않습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a2034951364 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 만들기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a2004719711 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 만들기 | " + d["0"]; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b989280850 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 만들기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1346752916 = messageFormatterFn((function(  ) {
  return function(d) { return "익스피디아, 호텔스닷컴 및 Vrbo에서 동일한 이메일 주소와 비밀번호를 사용해 로그인하실 수 있습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1643190476 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 만들기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a848044009 = messageFormatterFn((function(  ) {
  return function(d) { return "다른 보안 로그인 방법 외에 사용할 비밀번호를 설정해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1085057822 = messageFormatterFn((function(  ) {
  return function(d) { return "새 비밀번호 설정"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a332936645 = messageFormatterFn((function(  ) {
  return function(d) { return "새 비밀번호 설정 | " + d["0"]; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a991059336 = messageFormatterFn((function(  ) {
  return function(d) { return "새 비밀번호 설정"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b703049646 = messageFormatterFn((function(  ) {
  return function(d) { return "이제 익스피디아, 호텔스닷컴 및 Vrbo에서 하나의 계정을 사용해 로그인하실 수 있습니다. 통합 계정에 사용할 보안성이 높은 새 비밀번호를 만들어 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b2108050546 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 만들기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a661466394 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 변경"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1941184951 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호 변경 | " + d["0"]; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b159011882 = messageFormatterFn((function(  ) {
  return function(d) { return "흔하지 않으면서도 보안성이 높은 비밀번호를 사용해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a409368970 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호를 업데이트해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a876520439 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호를 업데이트하지 못했습니다. 다시 시도해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1824996651 = messageFormatterFn((function(  ) {
  return function(d) { return "비밀번호를 잊으셨나요?"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b230765595 = messageFormatterFn((function(  ) {
  return function(d) { return "이메일을 입력하면 로그인을 위한 보안 코드를 보내드립니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1688218395 = messageFormatterFn((function(  ) {
  return function(d) { return "이메일 보내기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1961166105 = messageFormatterFn((function(  ) {
  return function(d) { return "문의하기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b88604440 = messageFormatterFn((function(  ) {
  return function(d) { return "데이터 삭제"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b503905763 = messageFormatterFn((function(  ) {
  return function(d) { return "닫기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b2098923583 = messageFormatterFn((function(  ) {
  return function(d) { return "계정을 확인하는 동안 잠시만 기다려 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1135100766 = messageFormatterFn((function(  ) {
  return function(d) { return "계정 삭제"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1310262590 = messageFormatterFn((function(  ) {
  return function(d) { return "확인함"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b418534846 = messageFormatterFn((function(  ) {
  return function(d) { return "죄송합니다. 여행이 완료될 때까지 삭제할 수 없습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1049880477 = messageFormatterFn((function(  ) {
  return function(d) { return "예약을 변경해야 하는 경우 계정에 액세스하여 저희 고객 지원 담당자의 도움을 받으셔야 합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b2010686320 = messageFormatterFn((function(  ) {
  return function(d) { return "죄송합니다. 먼저 Vrbo 호스트 계정을 삭제해주셔야 합니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1411347943 = messageFormatterFn((function(  ) {
  return function(d) { return "웹사이트 또는 앱을 통해 지원 센터에 방문하거나 고객 지원에 직접 연락하여 절차를 시작해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b306433897 = messageFormatterFn((function(  ) {
  return function(d) { return "여행 완료 후 다시 시도해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1826766260 = messageFormatterFn((function(  ) {
  return function(d) { return "계정을 삭제하는 이유를 알려주시겠어요?"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b179052581 = messageFormatterFn((function(  ) {
  return function(d) { return "이메일 또는 알림이 너무 많음"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b746514575 = messageFormatterFn((function(  ) {
  return function(d) { return "다른 " + d["0"] + " 계정이 있음"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1401433708 = messageFormatterFn((function(  ) {
  return function(d) { return "여행이 끝났으므로 이 계정이 필요 없음"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1807088562 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "에서의 예약 경험이 좋지 않았음"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1465606867 = messageFormatterFn((function(  ) {
  return function(d) { return "기타"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a207247856 = messageFormatterFn((function(  ) {
  return function(d) { return "건너뛰기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b467607945 = messageFormatterFn((function(  ) {
  return function(d) { return "제출하기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b237718521 = messageFormatterFn((function(  ) {
  return function(d) { return "떠나신다니 아쉬워요! 계정을 삭제하기 전에 아래의 내용을 확인해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a229571558 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " 상당의 " + d["0"] + " 익스피디아 리워드 포인트, " + d["2"] + " 상당의 크레딧, 쿠폰, 저장된 여행 항목 및 계정 기본 설정 내역이 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1647193717 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " 상당의 " + d["0"] + " 익스피디아 리워드 포인트, 쿠폰, 저장된 여행 항목 및 계정 기본 설정 내역이 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a923066061 = messageFormatterFn((function(  ) {
  return function(d) { return "트립보드, 크레딧 및 기본 설정이 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1519486019 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com 호텔스닷컴 리워드: " + d["1"] + " 상당의 리워드 " + d["0"] + "박 및 스탬프" + d["2"] + "개(평균 가치: " + d["3"] + ")가 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b788755052 = messageFormatterFn((function(  ) {
  return function(d) { return "크레딧, 쿠폰, 저장된 여행 항목 및 계정 기본 설정 내역이 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1901704508 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " 상당의 " + d["0"] + " CheapCash, " + d["2"] + " 상당의 크레딧, 쿠폰, 저장된 여행 항목, 및 계정 기본 설정 내역이 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a571934325 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " 상당의 " + d["0"] + " CheapCash, 쿠폰, 저장된 여행 항목, 및 계정 기본 설정 내역이 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1309585356 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " 상당의 " + d["0"] + " Orbucks, " + d["2"] + " 상당의 크레딧, 쿠폰, 저장된 여행 항목, 및 계정 기본 설정 내역이 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1095540611 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " 상당의 " + d["0"] + " Orbucks, 쿠폰, 저장된 여행 항목, 및 계정 기본 설정 내역이 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b840154394 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " 상당의 " + d["0"] + " MrJet Rewards, " + d["2"] + " 상당의 크레딧, 쿠폰, 저장된 여행 항목, 및 계정 기본 설정 내역이 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1974326645 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " 상당의 " + d["0"] + " MrJet Rewards, 쿠폰, 저장된 여행 항목, 및 계정 기본 설정 내역이 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1624339364 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " 상당의 " + d["0"] + " BONUS+, " + d["2"] + " 상당의 크레딧, 쿠폰, 저장된 여행 항목, 및 계정 기본 설정 내역이 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b270894251 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " 상당의 " + d["0"] + " BONUS+, 쿠폰, 저장된 여행 항목, 및 계정 기본 설정 내역이 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a423783142 = messageFormatterFn((function(  ) {
  return function(d) { return "쿠폰, 저장된 여행 항목, 및 계정 기본 설정 내역이 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1152866427 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 상당의 크레딧, 쿠폰, 저장된 여행 항목, 및 계정 기본 설정 내역이 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1074188251 = messageFormatterFn((function(  ) {
  return function(d) { return "저희는 법적 의무를 이행하거나 법적 권리의 입증, 행사 또는 변호를 목적으로 거래 내역과 같은 일부 정보를 안전하게 보관할 수 있습니다. 이 정보는 안전하게 보관되며 더 이상 필요하지 않으면 삭제, 익명화 또는 영구 난독 처리됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b187435663 = messageFormatterFn((function(  ) {
  return function(d) { return "계정 영구 삭제"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a543147935 = messageFormatterFn((function(  ) {
  return function(d) { return "계정 삭제 안 함"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1393976427 = messageFormatterFn((function(  ) {
  return function(d) { return "곧 다시 뵐 수 있기를 바랍니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b2146369290 = messageFormatterFn((function(  ) {
  return function(d) { return "삭제 요청을 처리하는 데 몇 주가 소요될 수 있으며 시스템이 업데이트되는 동안 계속해서 메시지를 받으실 수 있는 점 미리 양해 부탁드립니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1502794128 = messageFormatterFn((function(  ) {
  return function(d) { return "다시 시도해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b2032624111 = messageFormatterFn((function(  ) {
  return function(d) { return "시스템 오류가 발생했습니다. 계정 삭제 요청을 다시 전송하거나 잠시 후 다시 시도해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a2129703961 = messageFormatterFn((function(  ) {
  return function(d) { return "닫기"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b681923918 = messageFormatterFn((function(  ) {
  return function(d) { return "여행 시 사용하시는 신분증에 등록된 이름은 무엇인가요?"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b992550178 = messageFormatterFn((function(  ) {
  return function(d) { return "여행 시 사용하시는 신분증(예: 여권 또는 면허증)의 이름과 계정 이름을 동일하게 작성해 주세요. 다음 예약 시 이 정보가 반영됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b771196084 = messageFormatterFn((function(  ) {
  return function(d) { return "특가 상품, 혜택 및 기타 정보가 포함된 " + d["0"] + "의 이메일을 받겠습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a992666275 = messageFormatterFn((function(  ) {
  return function(d) { return "특가 상품, 혜택 및 기타 정보가 포함된 " + d["0"] + "의 이메일을 받겠습니다. 언제든지 마케팅 이메일 수신을 거부하실 수 있습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b893119906 = messageFormatterFn((function(  ) {
  return function(d) { return "계정 정보"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1957443963 = messageFormatterFn((function(  ) {
  return function(d) { return "계정 정보 | " + d["0"]; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1461818828 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "의 특가 상품, 혜택 및 기타 정보를 수신하려면 클릭해 주세요. 나중에 언제든지 설정을 해제하실 수 있습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a592236504 = messageFormatterFn((function(  ) {
  return function(d) { return "계정 | " + d["0"]; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a883479056 = messageFormatterFn((function(  ) {
  return function(d) { return "실시간 여행 알리미"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1925023830 = messageFormatterFn((function(  ) {
  return function(d) { return "마케팅 수신 동의"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b792541723 = messageFormatterFn((function(  ) {
  return function(d) { return "익스피디아 리워드"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1398755997 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b95630763 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1049887293 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a723026085 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1561526684 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com 호텔스닷컴 리워드"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b381324696 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b2009774379 = messageFormatterFn((function(  ) {
  return function(d) { return "죄송하지만 여행이 완료될 때까지 기다려 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1587291035 = messageFormatterFn((function(  ) {
  return function(d) { return "죄송하지만 예정된 여행이 완료될 때까지 기다려 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b972636929 = messageFormatterFn((function(  ) {
  return function(d) { return "필요한 경우 계정을 통해 예약 세부 정보를 확인하고 고객 지원에 문의하실 수 있습니다. 여행 완료 후 다시 시도해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1641447355 = messageFormatterFn((function(  ) {
  return function(d) { return "필요한 경우 계정을 통해 예약 세부 정보를 확인하고 고객 지원에 문의하실 수 있습니다. 여행 완료 후 다시 시도해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a212447038 = messageFormatterFn((function(  ) {
  return function(d) { return "죄송하지만 현재 계정을 삭제할 수 없습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1832632856 = messageFormatterFn((function(  ) {
  return function(d) { return "이 계정은 Vrbo에서 숙박 시설을 호스트하는 데에도 사용됩니다. 계정을 삭제하시려면 먼저 Vrbo 호스트 앱 또는 사이트에 로그인하여 활성 상태의 숙박 시설을 삭제해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a563477703 = messageFormatterFn((function(  ) {
  return function(d) { return "계정을 삭제하는 이유를 알려주시겠어요?"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b806890300 = messageFormatterFn((function(  ) {
  return function(d) { return "다른 이메일로 계정이 있음"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b329857979 = messageFormatterFn((function(  ) {
  return function(d) { return "예약 경험이 좋지 않았음"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b285398822 = messageFormatterFn((function(  ) {
  return function(d) { return "떠나신다니 아쉽습니다. 계정 삭제 후에는 되돌릴 수 없으며 익스피디아, 호텔스닷컴 및 Vrbo 데이터에 영향을 미칩니다. 계정을 삭제하기 전에 아래의 내용을 확인해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a75206181 = messageFormatterFn((function(  ) {
  return function(d) { return "떠나신다니 아쉽습니다. 계정 삭제 후에는 되돌릴 수 없으며 익스피디아, Wotif, 호텔스닷컴 및 Vrbo 데이터에 영향을 미칩니다. 계정을 삭제하기 전에 아래의 내용을 확인해 주세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b2141306206 = messageFormatterFn((function(  ) {
  return function(d) { return "익스피디아, 호텔스닷컴 및 Vrbo에서 계정 기록, 기본 설정 및 저장된 항목이 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a415511021 = messageFormatterFn((function(  ) {
  return function(d) { return "익스피디아, Wotif, 호텔스닷컴 및 Vrbo에서 계정 기록, 기본 설정 및 저장된 항목이 영구 삭제됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b43286314 = messageFormatterFn((function(  ) {
  return function(d) { return "적립 대기 중인 OneKeyCash를 포함하여 모든 OneKeyCash 및 One Key 등급과 해당 특전이 영구 상실됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1489068340 = messageFormatterFn((function(  ) {
  return function(d) { return "적립 대기 중인 모든 OneKeyCash 및 One Key 등급과 해당 특전이 영구 상실됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b719063009 = messageFormatterFn((function(  ) {
  return function(d) { return "적립 대기 중인 모든 OneKeyCash를 포함하여 OneKeyCash " + d["0"] + " 및 One Key 등급과 해당 특전이 영구 상실됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1094361111 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com 호텔스닷컴 리워드 신용카드 소지자는 더 이상 카드 사용에 따른 리워드를 적립하실 수 없습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a772817588 = messageFormatterFn((function(  ) {
  return function(d) { return "확인되었거나 적립 대기 중인 모든 익스피디아 리워드 포인트, Hotels.com 호텔스닷컴 리워드 스탬프 및 리워드 숙박, 리워드 등급을 비롯한 모든 익스피디아 리워드 포인트가 영구 상실됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1553429930 = messageFormatterFn((function(  ) {
  return function(d) { return "적립 대기 중인 익스피디아 리워드 포인트, Hotels.com 호텔스닷컴 리워드 스탬프 및 리워드 숙박, 리워드 등급이 영구 상실됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b2038146192 = messageFormatterFn((function(  ) {
  return function(d) { return "익스피디아, 호텔스닷컴 또는 Vrbo의 모든 쿠폰 및 크레딧이 영구 상실됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1858340805 = messageFormatterFn((function(  ) {
  return function(d) { return "익스피디아, Wotif, 호텔스닷컴 또는 Vrbo의 모든 쿠폰 및 크레딧이 영구 상실됩니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1665022327 = messageFormatterFn((function(  ) {
  return function(d) { return "익스피디아, 호텔스닷컴 및 Vrbo 계정 삭제 요청을 처리하는 데 몇 주가 소요될 수 있으며 시스템이 업데이트되는 동안 계속해서 메시지를 받으실 수 있는 점 미리 양해 부탁드립니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1426527084 = messageFormatterFn((function(  ) {
  return function(d) { return "익스피디아, Wotif, 호텔스닷컴 및 Vrbo 계정 삭제 요청을 처리하는 데 몇 주가 소요될 수 있으며 시스템이 업데이트되는 동안 계속해서 메시지를 받으실 수 있는 점 미리 양해 부탁드립니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a556619326 = messageFormatterFn((function(  ) {
  return function(d) { return "계정을 삭제하시면 One Key Card 사용이 중단되며, 구매 시 더 이상 OneKeyCash를 적립하실 수 없습니다. Wells Fargo에서 카드 사용 중단 확인을 위해 연락을 드립니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1874432852 = messageFormatterFn((function(  ) {
  return function(d) { return "계정을 삭제하시면 One Key+ Card 사용이 중단되며, 구매 시 더 이상 OneKeyCash를 적립하실 수 없습니다. Wells Fargo에서 카드 사용 중단 확인을 위해 연락을 드립니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1523433471 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인하거나 계정을 생성해 여행에 대해 OneKeyCash를 적립해 보세요!"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1523452229 = messageFormatterFn((function(  ) {
  return function(d) { return "로그인하거나 회원가입해 이 숙박에 대해 리워드를 적립해 보세요!"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1638826178 = messageFormatterFn((function(  ) {
  return function(d) { return "비회원으로 결제"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1589221616 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 계정 로그인: 휴대폰 번호 추가"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b819126752 = messageFormatterFn((function(  ) {
  return function(d) { return "문제가 있는 것 같습니다."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b1223926234 = messageFormatterFn((function(  ) {
  return function(d) { return "다시 로그인해 보세요."; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a230578077 = messageFormatterFn((function(  ) {
  return function(d) { return "확인"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.a1932176060 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 로고"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b249753905 = messageFormatterFn((function(  ) {
  return function(d) { return "계정"; }
})(), Globalize("ko-KR").pluralGenerator({}));
Globalize.b380575621 = dateToPartsFormatterFn({"2":Globalize("ko-KR").numberFormatter({"raw":"00"}),"4":Globalize("ko-KR").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b1495121989 = dateToPartsFormatterFn({"2":Globalize("ko-KR").numberFormatter({"raw":"00"}),"4":Globalize("ko-KR").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b1495540018 = dateToPartsFormatterFn({"1":Globalize("ko-KR").numberFormatter({"raw":"0"}),"4":Globalize("ko-KR").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.a1676973320 = dateToPartsFormatterFn({"1":Globalize("ko-KR").numberFormatter({"raw":"0"}),"4":Globalize("ko-KR").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b1440980965 = dateToPartsFormatterFn({"2":Globalize("ko-KR").numberFormatter({"raw":"00"}),"4":Globalize("ko-KR").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a1253130448 = dateToPartsFormatterFn({"1":Globalize("ko-KR").numberFormatter({"raw":"0"}),"4":Globalize("ko-KR").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.a356741051 = dateToPartsFormatterFn({"2":Globalize("ko-KR").numberFormatter({"raw":"00"}),"4":Globalize("ko-KR").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b1386839941 = dateToPartsFormatterFn({"2":Globalize("ko-KR").numberFormatter({"raw":"00"}),"4":Globalize("ko-KR").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b857345669 = dateToPartsFormatterFn({"2":Globalize("ko-KR").numberFormatter({"raw":"00"}),"4":Globalize("ko-KR").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b1737111410 = dateToPartsFormatterFn({"1":Globalize("ko-KR").numberFormatter({"raw":"0"}),"4":Globalize("ko-KR").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a2135566363 = dateToPartsFormatterFn({"2":Globalize("ko-KR").numberFormatter({"raw":"00"}),"4":Globalize("ko-KR").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b1429360892 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"일","mon":"월","tue":"화","wed":"수","thu":"목","fri":"금","sat":"토"}}}});
Globalize.b184686597 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"일요일","mon":"월요일","tue":"화요일","wed":"수요일","thu":"목요일","fri":"금요일","sat":"토요일"}}}});
Globalize.b1437932037 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"1월","2":"2월","3":"3월","4":"4월","5":"5월","6":"6월","7":"7월","8":"8월","9":"9월","10":"10월","11":"11월","12":"12월"}}}});
Globalize.b905078587 = dateToPartsFormatterFn({"1":Globalize("ko-KR").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b1458872658 = dateToPartsFormatterFn({"1":Globalize("ko-KR").numberFormatter({"raw":"0"}),"2":Globalize("ko-KR").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a809529683 = dateToPartsFormatterFn({"1":Globalize("ko-KR").numberFormatter({"raw":"0"})}, {"pattern":"MMM d일","timeSeparator":":","months":{"M":{"3":{"1":"1월","2":"2월","3":"3월","4":"4월","5":"5월","6":"6월","7":"7월","8":"8월","9":"9월","10":"10월","11":"11월","12":"12월"}}}});
Globalize.b693744746 = dateToPartsFormatterFn({"1":Globalize("ko-KR").numberFormatter({"raw":"0"})}, {"pattern":"MMMM d일","timeSeparator":":","months":{"M":{"4":{"1":"1월","2":"2월","3":"3월","4":"4월","5":"5월","6":"6월","7":"7월","8":"8월","9":"9월","10":"10월","11":"11월","12":"12월"}}}});
Globalize.a2025770463 = dateToPartsFormatterFn({"1":Globalize("ko-KR").numberFormatter({"raw":"0"})}, {"pattern":"y년 MMMM d일","timeSeparator":":","months":{"M":{"4":{"1":"1월","2":"2월","3":"3월","4":"4월","5":"5월","6":"6월","7":"7월","8":"8월","9":"9월","10":"10월","11":"11월","12":"12월"}}}});
Globalize.b1320186527 = dateToPartsFormatterFn({"1":Globalize("ko-KR").numberFormatter({"raw":"0"})}, {"pattern":"y년 MMMM","timeSeparator":":","months":{"M":{"4":{"1":"1월","2":"2월","3":"3월","4":"4월","5":"5월","6":"6월","7":"7월","8":"8월","9":"9월","10":"10월","11":"11월","12":"12월"}}}});
Globalize.b1319501334 = dateToPartsFormatterFn({"1":Globalize("ko-KR").numberFormatter({"raw":"0"})}, {"pattern":"y년 MMM d일","timeSeparator":":","months":{"M":{"3":{"1":"1월","2":"2월","3":"3월","4":"4월","5":"5월","6":"6월","7":"7월","8":"8월","9":"9월","10":"10월","11":"11월","12":"12월"}}}});
Globalize.b1816942573 = dateToPartsFormatterFn({"1":Globalize("ko-KR").numberFormatter({"raw":"0"})}, {"pattern":"MMM d일 EEEE","timeSeparator":":","months":{"M":{"3":{"1":"1월","2":"2월","3":"3월","4":"4월","5":"5월","6":"6월","7":"7월","8":"8월","9":"9월","10":"10월","11":"11월","12":"12월"}}},"days":{"E":{"4":{"sun":"일요일","mon":"월요일","tue":"화요일","wed":"수요일","thu":"목요일","fri":"금요일","sat":"토요일"}}}});
Globalize.b701132914 = dateToPartsFormatterFn({"1":Globalize("ko-KR").numberFormatter({"raw":"0"})}, {"pattern":"MMM d일 (E)","timeSeparator":":","months":{"M":{"3":{"1":"1월","2":"2월","3":"3월","4":"4월","5":"5월","6":"6월","7":"7월","8":"8월","9":"9월","10":"10월","11":"11월","12":"12월"}}},"days":{"E":{"1":{"sun":"일","mon":"월","tue":"화","wed":"수","thu":"목","fri":"금","sat":"토"}}}});
Globalize.b1861870 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b1116408238 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a319377189 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b803076769 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b1062267214 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b1226919641 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a735454802 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b1008126190 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b478631918 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a77805797 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b1780687182 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b1580534259 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b1020847150 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a2020874706 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b321794994 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"raw":"d"}));
Globalize.b1850279739 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1237388252 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b315030995 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.a880994856 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b941472776 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b940787583 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.a1860294172 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b322419163 = dateFormatterFn(Globalize("ko-KR").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a1612199873 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a497653505 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.b470003820 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b1592457778 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a551794529 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b2016300650 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.b1945450751 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a605935553 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a1135429825 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.b711575212 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b166625439 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a225600510 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^일/],["mon",/^월/],["tue",/^화/],["wed",/^수/],["thu",/^목/],["fri",/^금/],["sat",/^토/]]});
Globalize.b1932416063 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["sun",/^일요일/],["mon",/^월요일/],["tue",/^화요일/],["wed",/^수요일/],["thu",/^목요일/],["fri",/^금요일/],["sat",/^토요일/]]});
Globalize.a1109305793 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["10",/^10월/],["11",/^11월/],["12",/^12월/],["1",/^1월/],["2",/^2월/],["3",/^3월/],["4",/^4월/],["5",/^5월/],["6",/^6월/],["7",/^7월/],["8",/^8월/],["9",/^9월/]]});
Globalize.b1879582017 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b1694676748 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1758586547 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMM d일","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["10",/^10월/],["11",/^11월/],["12",/^12월/],["1",/^1월/],["2",/^2월/],["3",/^3월/],["4",/^4월/],["5",/^5월/],["6",/^6월/],["7",/^7월/],["8",/^8월/],["9",/^9월/]]});
Globalize.a1299030748 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMMM d일","digitsRe":/\d/,"gregorian/months/format/wide":[["10",/^10월/],["11",/^11월/],["12",/^12월/],["1",/^1월/],["2",/^2월/],["3",/^3월/],["4",/^4월/],["5",/^5월/],["6",/^6월/],["7",/^7월/],["8",/^8월/],["9",/^9월/]]});
Globalize.b622698663 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"y년 MMMM d일","digitsRe":/\d/,"gregorian/months/format/wide":[["10",/^10월/],["11",/^11월/],["12",/^12월/],["1",/^1월/],["2",/^2월/],["3",/^3월/],["4",/^4월/],["5",/^5월/],["6",/^6월/],["7",/^7월/],["8",/^8월/],["9",/^9월/]]});
Globalize.a672588967 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"y년 MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["10",/^10월/],["11",/^11월/],["12",/^12월/],["1",/^1월/],["2",/^2월/],["3",/^3월/],["4",/^4월/],["5",/^5월/],["6",/^6월/],["7",/^7월/],["8",/^8월/],["9",/^9월/]]});
Globalize.a673274160 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"y년 MMM d일","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["10",/^10월/],["11",/^11월/],["12",/^12월/],["1",/^1월/],["2",/^2월/],["3",/^3월/],["4",/^4월/],["5",/^5월/],["6",/^6월/],["7",/^7월/],["8",/^8월/],["9",/^9월/]]});
Globalize.b80166131 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMM d일 EEEE","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["10",/^10월/],["11",/^11월/],["12",/^12월/],["1",/^1월/],["2",/^2월/],["3",/^3월/],["4",/^4월/],["5",/^5월/],["6",/^6월/],["7",/^7월/],["8",/^8월/],["9",/^9월/]],"gregorian/days/format/wide":[["sun",/^일요일/],["mon",/^월요일/],["tue",/^화요일/],["wed",/^수요일/],["thu",/^목요일/],["fri",/^금요일/],["sat",/^토요일/]]});
Globalize.a1291642580 = dateParserFn(Globalize("ko-KR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMM d일 (E)","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["10",/^10월/],["11",/^11월/],["12",/^12월/],["1",/^1월/],["2",/^2월/],["3",/^3월/],["4",/^4월/],["5",/^5월/],["6",/^6월/],["7",/^7월/],["8",/^8월/],["9",/^9월/]],"gregorian/days/format/abbreviated":[["sun",/^일/],["mon",/^월/],["tue",/^화/],["wed",/^수/],["thu",/^목/],["fri",/^금/],["sat",/^토/]]});
module.exports = Globalize;
